/**
 * Device login approval RBAC (aligned with profile edit request review).
 * Backend: ERPInstituteBackend/utils/deviceApprovalScope.util.js
 */

const PROFILE_STUDENT_REVIEW = ["student.profile.update"];
const PROFILE_STAFF_REVIEW = ["teacher.profile.update"];

export const DEVICE_STUDENT_READ_PERMS = [
  "device.student.read",
  "device.student.approve",
  "device.student.reject",
  ...PROFILE_STUDENT_REVIEW,
];

export const DEVICE_STAFF_READ_PERMS = [
  "device.staff.read",
  "device.staff.approve",
  "device.staff.reject",
  ...PROFILE_STAFF_REVIEW,
];

export const DEVICE_STUDENT_APPROVE_PERMS = [
  "device.student.approve",
  ...PROFILE_STUDENT_REVIEW,
];

export const DEVICE_STAFF_APPROVE_PERMS = [
  "device.staff.approve",
  ...PROFILE_STAFF_REVIEW,
];

export const DEVICE_STUDENT_REJECT_PERMS = [
  "device.student.reject",
  "device.student.approve",
  ...PROFILE_STUDENT_REVIEW,
];

export const DEVICE_STAFF_REJECT_PERMS = [
  "device.staff.reject",
  "device.staff.approve",
  ...PROFILE_STAFF_REVIEW,
];

export const DEVICE_ANY_REVIEW_MENU_PERMS = [
  ...new Set([...DEVICE_STUDENT_READ_PERMS, ...DEVICE_STAFF_READ_PERMS]),
];
